export default __webpack_public_path__ + "risk_mapping.png";